/* eslint-disable react/no-deprecated */
import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { importApp } from './utils';
import { IReduxStore } from '../../../shared/common/types/redux';
import { IApplicationContext } from '../../../shared/common/types/applicationContext';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export async function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  const App = await importApp(context.custom.pageName);

  hydrateRoot(rootElement, <App context={context} reduxStore={store} />);
}
